/* =========================================================================
   Brain2Canvas — Referenzen: gemeinsame Basis für Übersicht und Case-Seiten
   Kein Framework, keine externe Library.

   1. Reveal (slide-only, IntersectionObserver) — Content ist ohne JS sichtbar
   2. Buchstaben-Hover an der Band-Headline
   3. Tracking als dataLayer.push
   ========================================================================= */
(function () {
  'use strict';

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.B2C = window.B2C || {};

  /* -------------------------------------------------- 1. Reveal ---------- */
  var io = null;
  function bindReveals(root) {
    var scope = root || document;
    if (reduce) {
      scope.querySelectorAll('.reveal').forEach(function (e) { e.classList.add('in'); });
      return;
    }
    scope.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < innerHeight * 0.95) el.classList.add('in');
    });
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    }
    scope.querySelectorAll('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
  }
  window.B2C.bindReveals = bindReveals;

  bindReveals();
  // Sicherheitsnetz: nach 1,2 s ist alles sichtbar, egal was passiert ist
  setTimeout(function () {
    document.querySelectorAll('.reveal:not(.in)').forEach(function (e) { e.classList.add('in'); });
  }, 1200);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') bindReveals();
  });

  /* --------------------------------------- 2. Buchstaben-Hover H1 -------- */
  function splitLetters(root) {
    root.querySelectorAll('.bandline__band').forEach(function (band) {
      var walker = document.createTreeWalker(band, NodeFilter.SHOW_TEXT);
      var texts = [];
      while (walker.nextNode()) texts.push(walker.currentNode);
      texts.forEach(function (node) {
        var frag = document.createDocumentFragment();
        node.nodeValue.split('').forEach(function (ch) {
          if (ch === ' ') { frag.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span');
          s.className = 'ltr';
          s.textContent = ch;
          frag.appendChild(s);
        });
        node.parentNode.replaceChild(frag, node);
      });
    });

    var bands = [].slice.call(root.querySelectorAll('.bandline__band'))
      .map(function (b) { return [].slice.call(b.querySelectorAll('.ltr')); });
    if (!bands.length) return;

    var current = -1;
    function setHot(i) {
      if (i === current) return;
      bands.forEach(function (list) {
        if (current > -1 && list[current]) list[current].classList.remove('hot');
        if (i > -1 && list[i]) list[i].classList.add('hot');
      });
      current = i;
    }
    root.addEventListener('pointermove', function (ev) {
      var t = ev.target.closest ? ev.target.closest('.ltr') : null;
      if (!t) { setHot(-1); return; }
      var idx = -1;
      bands.forEach(function (l) { var k = l.indexOf(t); if (k > -1) idx = k; });
      setHot(idx);
    }, { passive: true });
    root.addEventListener('pointerleave', function () { setHot(-1); }, { passive: true });
  }

  var headline = document.querySelector('.bandline[data-letters]');
  if (headline) splitLetters(headline);
  requestAnimationFrame(function () {
    document.querySelectorAll('.bandline').forEach(function (b) { b.classList.add('in'); });
  });
  // Nach dem Band-Reveal (620ms + 140ms Stagger) darf die Zeile ueber ihre
  // Clip-Kante hinausragen: der Hover-Buchstabe hebt sich sonst ins Nichts.
  setTimeout(function () {
    document.querySelectorAll('.bandline').forEach(function (b) { b.classList.add('settled'); });
  }, reduce ? 0 : 820);

  /* -------------------------------------------------- 3. Tracking -------- */
  var dl = (window.dataLayer = window.dataLayer || []);
  function push(o) { dl.push(o); }
  window.B2C.track = push;

  var page = document.body.getAttribute('data-page');

  // ref_case_view: eine Case-Seite wurde geöffnet
  if (page === 'case') {
    push({
      event: 'ref_case_view',
      ref_case: document.body.getAttribute('data-case'),
      ref_category: document.body.getAttribute('data-cat')
    });
  }

  // ref_cta_click: jeder Anfrage-CTA und jede kommerzielle Kante
  document.addEventListener('click', function (ev) {
    var cta = ev.target.closest && ev.target.closest('[data-cta]');
    if (cta) {
      push({
        event: 'ref_cta_click',
        ref_cta_position: cta.getAttribute('data-cta'),
        ref_page: page || 'unbekannt'
      });
      return;
    }
    var edge = ev.target.closest && ev.target.closest('[data-edge]');
    if (edge) {
      push({
        event: 'ref_cta_click',
        ref_cta_position: 'edge_' + edge.getAttribute('data-edge'),
        ref_page: page || 'unbekannt'
      });
    }
  }, { passive: true });

  // ref_scroll_75: einmalig, wenn 75 % der Seite gelesen sind
  (function () {
    var fired = false;
    function check() {
      if (fired) return;
      var doc = document.documentElement;
      var max = doc.scrollHeight - innerHeight;
      if (max <= 0) return;
      if ((doc.scrollTop || document.body.scrollTop) / max >= 0.75) {
        fired = true;
        push({ event: 'ref_scroll_75', ref_page: page || 'unbekannt' });
        removeEventListener('scroll', onScroll);
      }
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; check(); });
    }
    addEventListener('scroll', onScroll, { passive: true });
  })();
})();
